import _ from "lodash";
import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class InsertionOrderDataStore extends EventEmitter {
	constructor() {
		super();

		this.insertionorder = {
			data: [],
			config: [],
			errors: [],
			filteredData: [],
			defaultSelection: null,
			navigate: false
		};

		/*
        Need to register all actions with the AppDispatcher
        */

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchInsertionOrders:
					const hierarchyData = action.value.data;
					hierarchyData.forEach((dataField) => {
						if (dataField.TaxonomyData) {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.TaxonomyData.forEach((configTaxonomyField) => {
										if (
											configTaxonomyField.ID === dataTaxonomyField.DataKeyID &&
											configTaxonomyField.Name !== dataTaxonomyField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configTaxonomyField.Name] = dataField[dataTaxonomyField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
						if (dataField.MetaData) {
							JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
								if (dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")]) {
									action.value.config.MetaData.forEach((configMetaDataField) => {
										if (
											configMetaDataField.ID === dataMetaDataField.DataKeyID &&
											configMetaDataField.Name !== dataMetaDataField.DataKeyShortDescr.split(" ").join("")
										) {
											dataField[configMetaDataField.Name] = dataField[dataMetaDataField.DataKeyShortDescr.split(" ").join("")];
										}
									});
								}
							});
						}
					});
					this.insertionorder.config = action.value.config;
					this.insertionorder.data = hierarchyData;
					this.emit("insertionorder_loaded");
					break;
				case AppActionConstants.fetchOnlyInsertionOrders:
					const onlyIOConfig = this.insertionorder.config;
					const onlyIOData = this.updateExistingValues(action.value, onlyIOConfig);
					this.insertionorder.data = onlyIOData;
					this.emit("only_IO_fetched");
					break;
				case AppActionConstants.setFilteredInsertionOrders:
					this.insertionorder.filteredData = action.value;
					this.emit("filteredData");
					break;
				case AppActionConstants.createInsertionOrderSuccess:
					this.insertionorder.data = [...this.insertionorder.data, action.value];
					if (action.cloneIO === true) {
						this.emit("duplicate_insertionorder_success");
					} else {
						this.emit("insertionorder_success");
					}
					break;
				case AppActionConstants.createChildLineItems:
					this.insertionorder.data = [action.value, ...this.insertionorder.data];
					break;
				case AppActionConstants.createInsertionOrderFail:
					const errorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								errorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						errorObject.Errors = [action.value.Errors];
					}
					this.insertionorder.errors = errorObject;
					if (action.cloneIO === true) {
						this.emit("duplicate_insertionOrder_fail");
					} else {
						this.emit("insertionorder_fail");
					}
					this.emit("insertionorder_fail");
					break;
				case AppActionConstants.editInsertionOrderSuccess:
					this.insertionorder.data.splice(action.row, 1, action.value);
					this.insertionorder.data = [...this.insertionorder.data];
					this.emit("insertionorder_edit_success");
					break;
				case AppActionConstants.editInsertionOrderFail:
					const editErrorObject = {};
					if (action.value.InputErrors) {
						action.value.InputErrors.forEach((error) => {
							Object.keys(error).forEach((errorName) => {
								editErrorObject[errorName] = error[errorName];
							});
						});
					}
					if (action.value.Errors) {
						editErrorObject.Errors = [action.value.Errors];
					}
					this.insertionorder.errors = editErrorObject;
					this.emit("insertionorder_edit_fail");
					break;
				case AppActionConstants.createAndAddInsertionOrderSuccess:
					this.insertionorder.data = [...this.insertionorder.data, action.value];

					const defaultLabel = action.value.InsertionOrderName;
					const defaultValue = action.value.InsertionOrderID;
					this.insertionorder.defaultSelection = { label: defaultLabel, value: defaultValue };
					this.insertionorder.navigate = true;

					this.emit("create_and_add_children_success");
					break;
				case AppActionConstants.deleteInsertionOrderSuccess:
					this.insertionorder.data = action.value;
					if (this.insertionorder.filteredData.length !== 0) {
						const filteredData = JSON.parse(JSON.stringify(this.insertionorder.filteredData));
						this.insertionorder.filteredData = filteredData.filter((filteredIO) => {
							return !action.deletedIDs.includes(filteredIO.InsertionOrderID.toString());
						});
					}
					this.emit("insertionorder_deleted");
					break;
				case AppActionConstants.duplicateInsertionOrder:
					this.emit("duplicate_insertionorder_success");
					break;
				case AppActionConstants.duplicateInsertionOrderFail:
					this.emit("duplicate_insertionorder_fail");
					break;
				case AppActionConstants.updateIOSyncStatus:
					this.insertionorder.data.forEach((io) => {
						if (action.value.includes(io.InsertionOrderID)) {
							io.ExternalSystemStatusID = "4";
							io.ExternalSystemResponse = "Sent to Queue";
						}
					});
					this.emit("sync_status_updated");
					break;
				default:
					break;
			}
		});
	}

	/*
    Getter function to return the current state
    */
	getData = () => this.insertionorder.data;
	getFilteredData = () => this.insertionorder.filteredData;
	getConfig = () => this.insertionorder.config;
	getErrors = () => this.insertionorder.errors;
	getDefaultValue = () => this.insertionorder.defaultSelection;
	getNavigate = () => this.insertionorder.navigate;

	setNavigate = (nav) => (this.insertionorder.navigate = nav);

	resetDefaultValue = () => {
		this.insertionorder.defaultSelection = null;
	};

	updateChildCount = (insertionOrderID, updatedCount) => {
		this.insertionorder.data.forEach((io) => {
			if (io.InsertionOrderID === insertionOrderID) {
				io.ChildCount = updatedCount ? updatedCount.toString() : (parseInt(io.ChildCount) + 1).toString();
			}
		});
		if (this.insertionorder.filteredData.length !== 0) {
			this.insertionorder.filteredData.forEach((io) => {
				if (io.InsertionOrderID === insertionOrderID) {
					io.ChildCount = updatedCount ? updatedCount.toString() : (parseInt(io.ChildCount) + 1).toString();
				}
			});
		}
		this.emit("insertionorder__childCountUpdated");
	};

	resetInsertionOrderErrors = () => {
		this.insertionorder.errors = [];
		this.emit("insertionorder__errors__reset");
	};

	resetInsertionOrderData = () => {
		this.insertionorder.config = [];
	};

	returnDataRow = (row) => {
		return this.insertionorder.data[row];
	};

	returnFilteredDataRow = (row) => {
		return this.insertionorder.filteredData[row];
	};

	updateDataManually = (data, bundle) => {
		for (const key in bundle) {
			if (bundle[key].Result === true) {
				const newRow = this.getFilteredData().length !== 0 ? this.returnFilteredDataRow(key) : this.returnDataRow(key);
				if (newRow) {
					newRow.InsertionOrderName = bundle[`${key}`].Object.InsertionOrderName;
					newRow.UniqueID = bundle[`${key}`].Object.UniqueID;
					if (bundle[`${key}`].Object.ParentUniqueIDCode) {
						newRow.ParentUniqueIDCode = bundle[`${key}`].Object.ParentUniqueIDCode;
					}
					newRow.InsertionOrderID = bundle[`${key}`].Object.InsertionOrderID;
				} else {
					const existingRow = data.filter((lineItem) => lineItem.UniqueID === key);
					if (existingRow[0]) {
						existingRow[0].UniqueID = bundle[`${key}`].Object.UniqueID;
						existingRow[0].InsertionOrderName = bundle[`${key}`].Object.InsertionOrderName;
					}
				}
			}
		}
	};

	updateExistingValues = (data, config) => {
		const newData = data;
		const fieldNames = {};
		const fieldIds = {};
		const excludedFieldNames = ["CampaignID", "UniqueID", "TaxonomyData", "MetaData", "InsertionOrderName", "InsertionOrderID", "IsArchived", "IsDeleted", "UpdatedBy"];
		config.TaxonomyData.forEach((taxonomyField) => {
			fieldNames[taxonomyField.Name] = taxonomyField.ID;
			fieldIds[taxonomyField.ID] = taxonomyField.Name;
		});
		config.MetaData.forEach((metadataField) => {
			fieldNames[metadataField.Name] = metadataField.ID;
			fieldIds[metadataField.ID] = metadataField.Name;
		});
		config.InsertionOrderData.forEach((placementField) => {
			fieldNames[placementField.Name] = placementField.ID;
			fieldIds[placementField.ID] = placementField.Name;
		});
		newData.forEach((dataField) => {
			if (!_.isEmpty(dataField)) {
				Object.keys(dataField).forEach((dataKeyName) => {
					if (!excludedFieldNames.includes(dataKeyName) && !Object.keys(fieldNames).includes(dataKeyName)) {
						let matchingId = null;
						if (dataField.TaxonomyData !== "") {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (matchingId !== null) {
									return;
								}
								if (dataTaxonomyField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
									matchingId = dataTaxonomyField.DataKeyID;
								}
							});
						}
						if (matchingId === null) {
							if (dataField.MetaData !== "") {
								JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
									if (matchingId !== null) {
										return;
									}
									if (dataMetaDataField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
										matchingId = dataMetaDataField.DataKeyID;
									}
								});
							}
						}
						if (matchingId !== null) {
							if (fieldIds[matchingId]) {
								dataField[fieldIds[matchingId]] = dataField[dataKeyName];
							}
						}
					}
				});
			}
		});
		return newData;
	};
}

export default new InsertionOrderDataStore();
